import { Expense } from "@quantizr-engineering/common/types/show";
import { Release, Recording, Format, Revenue } from "./Recorded";

export interface CollabRow {
  title: string;
  type: "Recording" | "Composition";
  publishingRights: boolean;
  split: number;
  mechanicals: number;
  releaseDate: string;
}

export interface CollaboratorDataRow {
  legalName: string;
  email: string;
  artistName: string;
  children: CollabRow[];
  totalRevenue?: number;
  totalExpenses?: number;
  netProfit?: number;
}

export class CollaboratorDataRowAdapter {
  groupRevenuesByType(revenues: Revenue[]): { [key: string]: number } {
    return revenues.reduce((acc, revenue) => {
      acc[revenue.type] = (acc[revenue.type] || 0) + revenue.amount;
      return acc;
    }, {} as { [key: string]: number });
  }

  calculateTotalExpenses(expenses: Expense[]): number {
    return expenses.reduce(
      (total, expense) => total + expense.cost * expense.quantity,
      0
    );
  }

  ToCollabData(releases: Release[]): CollaboratorDataRow[] {
    const collaboratorMap = new Map<string, CollaboratorDataRow>();
    releases
      .flatMap((release) => release.recordings)
      .filter(
        (recording, index, self) =>
          self.findIndex((r) => r.id === recording.id) === index
      )
      .forEach((recording) => {
        recording.collabs?.forEach((collab) => {
          if (!collaboratorMap.has(collab.person.legalName)) {
            collaboratorMap.set(collab.person.legalName, {
              legalName: collab.person.legalName,
              email: collab.person.email,
              artistName: collab.person.artistName,
              totalRevenue: 0,
              totalExpenses: 0,
              netProfit: 0,
              children: [],
            });
          }

          const expenses = this.calculateTotalExpenses(
            recording?.expenses ?? []
          );
          const collabData = collaboratorMap.get(collab.person.legalName)!;

          collabData.children.push({
            type: "Recording",
            title: recording.title,
            releaseDate: new Date(recording.releaseDate)
              .toISOString()
              .split("T")[0],
            split: collab.split,
            publishingRights: collab.publishingRights,
            mechanicals: collab.mechanicals,
          });

          collabData.totalExpenses! += expenses * (collab.split / 100);
          // collabMap.set(collab.person.email, collabData);
        });
      });

    return Array.from(collaboratorMap.values());
  }
}
